const isDev = import.meta.env.DEV;

export const SW_URL = isDev ? "/dev-sw.js?dev-sw" : "/sw.js";

export const SW_SCOPE = "/";

export interface PwaDiagnosticsPayload {
  event: string;
  stage: string;
  message: string;
  details?: Record<string, unknown>;
  sw_scope?: string;
  sw_url?: string;
  permission?: NotificationPermission;
  registration_state?: string;
  controller_present?: boolean;
  user_agent?: string;
}

interface PostPwaDiagnosticsOptions {
  organizationId: number;
  csrfToken: string;
  payload: PwaDiagnosticsPayload;
}

const pwaDiagnosticsPath = (organizationId: number) =>
  `/organizations/${organizationId}/pwa/diagnostics`;

export const buildPwaDiagnosticsPayload = (
  payload: PwaDiagnosticsPayload,
): PwaDiagnosticsPayload => ({
  ...payload,
  sw_scope: payload.sw_scope ?? SW_SCOPE,
  sw_url: payload.sw_url ?? SW_URL,
  permission:
    payload.permission ??
    (typeof Notification === "undefined" ? undefined : Notification.permission),
  controller_present:
    payload.controller_present ??
    (typeof navigator === "undefined"
      ? false
      : Boolean(navigator.serviceWorker?.controller)),
  user_agent:
    payload.user_agent ??
    (typeof navigator === "undefined" ? undefined : navigator.userAgent),
});

export const postPwaDiagnostics = async ({
  organizationId,
  csrfToken,
  payload,
}: PostPwaDiagnosticsOptions) => {
  const response = await fetch(pwaDiagnosticsPath(organizationId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    credentials: "same-origin",
    body: JSON.stringify(buildPwaDiagnosticsPayload(payload)),
  });

  if (!response.ok) {
    throw new Error(`Diagnostics request failed with status ${response.status}.`);
  }
};
